import popoutReadingPane from 'owa-popout-utils/lib/utils/popoutReadingPane';
import getMailItemByImmutableIdOrItemId from './getMailItemByImmutableIdOrItemId';
import type Message from 'owa-service/lib/contract/Message';

export default async function popoutMailItemFromMessage(message: Message) {
    // Recalculate the itemID (getMailItemByImmutableIdOrItemId)
    // as the item might have changed since the time we cached the item preview.
    const item = await getMailItemByImmutableIdOrItemId(
        undefined /** immutableId */,
        message?.ItemId?.Id
    );
    if (item?.ItemId) {
        popoutReadingPane(item.ItemId.Id);
    }
}
